module.exports = __webpack_public_path__ + "img/002.f3a3f018.jpg";